var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubspotContactEmailsFinder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3f1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24653,
    stopColor: "#f0b5a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#ff7a59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e14859"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.27316,36.7401h5.3229c.83996,0,1.52088-.68091,1.52088-1.52088,0-.83991-.68091-1.52083-1.52088-1.52083h-5.3229c-.83996,0-1.52088.68091-1.52088,1.52083,0,.83996.68091,1.52088,1.52088,1.52088Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.27316,51.52094h5.3229c.83996,0,1.52088-.68091,1.52088-1.52088,0-.83991-.68091-1.52083-1.52088-1.52083h-5.3229c-.83996,0-1.52088.68091-1.52088,1.52083,0,.83996.68091,1.52088,1.52088,1.52088Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.59606,66.30177c.42001,0,.80021-.1702,1.07544-.44543.27523-.27518.44543-.65544.44543-1.07539v-.00005c0-.83991-.68091-1.52083-1.52088-1.52083h-5.3229c-.83996,0-1.52088.68091-1.52088,1.52083,0,.83996.68091,1.52088,1.52088,1.52088h5.3229Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.91458,27.11978h-31.64679c-1.28857,0-2.33319,1.04462-2.33319,2.33319v2.62128h2.6615c1.73413,0,3.14496,1.41083,3.14496,3.14496s-1.41083,3.14496-3.14496,3.14496h-2.6615v8.49091h2.6615c1.73413,0,3.14496,1.41083,3.14496,3.14496s-1.41083,3.14496-3.14496,3.14496h-2.6615v8.49091h2.6615c1.73413,0,3.14496,1.41083,3.14496,3.14502,0,1.73407-1.41083,3.14496-3.14496,3.14496h-2.6615v2.62122c0,1.28857,1.04462,2.33313,2.33319,2.33313h31.64679c1.28857,0,2.33313-1.04456,2.33313-2.33313V29.45297c0-1.28857-1.04456-2.33319-2.33313-2.33319Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspotContactEmailsFinder);
export default __webpack_public_path__ + "static/media/hubspot-contact-emails-finder.2fa1e37c155560f775dfe9a786dc6aeb.svg";
export { ForwardRef as ReactComponent };